//@flow
import { asyncComponent } from 'react-async-component'
import LoadingComponent from '../../LoadingComponent'
import ErrorComponent from '../../ErrorComponent'

export default asyncComponent({
  resolve: () => import('./Panel'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncPanel',
})



// WEBPACK FOOTER //
// ./src/components/QuestionElements/Panel/index.js